import { Injectable } from '@angular/core';
import { CoreRepository } from '@tcc-mono/shared/data-access';
import { Ride } from '@tcc-mono/vandijk/shared/data-access/models';
import { AppRideService } from '@tcc-mono/vandijk/shared/data-access/vandijk-api';
import { Observable, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppRideRepository extends CoreRepository<Ride> {

  public constructor(
    protected readonly _appRideService: AppRideService
  ) {
    super(
      { name: 'appRides' },
      _appRideService
    );
  }

  public addAnimal(
    rideId: PropertyKey,
    body: any,
    override: boolean = false
  ): Observable<any> {
    return this._appRideService.addAnimal(
      rideId,
      body,
      override
    );
  }

  public deleteAnimal(
    rideId: PropertyKey,
    animalId: PropertyKey
  ): Observable<any> {
    return this._appRideService.deleteAnimal(
      rideId,
      animalId
    );
  }

  public finishRide = (rideId: PropertyKey): Observable<Ride> => {
    return this._appRideService
      .post({}, `${rideId.toString()}/scanning_done`)
      .pipe(
        switchMap(() => this.getEntity(rideId, false, true))
      );
  };
}
